import axios from './axiosInstance';

export const searchUsers = async (q = '', page = 1, limit = 20) => {
    const res = await axios.get('/api/admin/users', { params: { q, page, limit } });
    return res.data;
};

export const changeUserStatus = async (username, status) => {
    const res = await axios.post('/api/admin/change-status', { username, status });
    return res.data;
};

export const changeUserRole = async (username, role) => {
    const res = await axios.post('/api/admin/change-role', { username, role });
    return res.data;
};
